import { createFileRoute } from "@tanstack/react-router";
import { AdminTransactionsPage } from "@/components/admin/pages/AdminTransactionsPage";

export const Route = createFileRoute("/pulse-ops-x7k2/transactions")({
  component: AdminTransactionsPage,
});
